import classNames from 'classnames'
import { AddToCalendarData, AddToCalendarDataVariables } from 'globalTypes'

import { useQuery } from '@apollo/client'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu } from '@headlessui/react'
import Link from 'Root/Component/Link'
import map from 'lodash/map'

import QUERY from './add-to-calendar-data.graphql'
import styles from './index.module.css'
import { getCalendars } from './utilities'

interface Props {
  id: string
}

library.add(faCalendar)

const AddToCalendarLinks = ({ id }: Props) => {
  const { data, loading } = useQuery<
    AddToCalendarData,
    AddToCalendarDataVariables
  >(QUERY, {
    variables: {
      identifier: id,
    },
  })

  if (loading) {
    return null
  }

  const content = data.content
  if (!Boolean(content) || content.__typename !== 'EventContent') {
    return null
  }

  const calendars = getCalendars(content)

  return (
    <div className={styles.container}>
      <div className={styles.header}>Aggiungi al calendario</div>
      {map(calendars, ({ icon, link }, name) => (
        <Menu.Item key={name}>
          {({ active }) => (
            <Link
              className={classNames(
                active ? styles.active : styles.notActive,
                styles.item
              )}
              target="_blank"
              to={link}
            >
              <img className={styles.icon} src={icon} alt={name} />
              {name}
            </Link>
          )}
        </Menu.Item>
      ))}
      <Menu.Item>
        {({ active }) => (
          <Link
            className={classNames(
              active ? styles.active : styles.notActive,
              styles.item
            )}
            target="_blank"
            to={`/_/ical/${content.id}`}
          >
            <FontAwesomeIcon
              className={styles.icon}
              icon={['fas', 'calendar']}
            />
            iCalendar
          </Link>
        )}
      </Menu.Item>
    </div>
  )
}

export default AddToCalendarLinks
